// emptyReturn - value to return if no value found
export const highlightMatchedField = (fieldName, doc, emptyReturn) => {
  const { matched = {} } = doc;
  if (matched[fieldName]) {
    return matched[fieldName];
  }
  return doc[fieldName] || emptyReturn;
};
